import { get, del } from '../..';
import { buildFrontlineUrl } from '../../../utils';
import {
  ISupportTask,
  IDeleteTaskResponse,
} from '../../../interfaces/support/task';

export const getSupportTask = (taskId: string, domainId: string) =>
  get<ISupportTask>(
    buildFrontlineUrl(`/v3/back-office/tasks/${taskId}?domainId=${domainId}`),
  );

export const deleteSupportTask = (
  taskId: string,
  reason: string,
  ticket: string,
  domainId: string,
) =>
  del<IDeleteTaskResponse>(
    buildFrontlineUrl(`/v3/back-office/tasks/${taskId}`),
    {
      reason,
      ticket,
      domainId,
    },
  );
